module.exports = __webpack_public_path__ + "static/media/undraw_trip_re_f724.c644db9d.svg";